export const iconFontAwesomeReligionBookJournalWhills = (
	<i className="fa-solid fa-book-journal-whills"></i>
);
